
<p-table #packetView [(value)]="packets" dataKey="id" (onRowSelect)="rowSelected()" selectionMode="single"
    [(selection)]="rowSelectedPacket" [tableStyle]="{'min-width': '55rem'}">
    <ng-template pTemplate="header">
        <tr>
            <th scope="col">
                <span class="font-semibold">Packet</span>
            </th>
            <th scope="col">
                <span class=" font-semibold">Checklist</span>
            </th>
            <th scope="col">
                <span class="font-semibold">Add</span>
            </th>
            <th scope="col">
                &nbsp;
            </th>
        </tr>
        <tr>
            <th colspan="4">
                <input #addId [disabled]="!active" class="tw-w-6/12" type="text" pInputText [(ngModel)]="newPacketId" />
                <button [disabled]="!active || addId.value.trim() ===''" pButton pRipple type="button"
                    icon="pi pi-plus" (click)="addPacket($event)"
                    class="p-button-rounded p-button-text p-button-success mr-2"></button>
            </th>
        </tr>

    </ng-template>
    <ng-template let-packet pTemplate="body">
        <tr [pSelectableRow]="packet">
            <td>
                {{packet.id}} <br />
            </td>
            <td>
                <p-checkbox [value]="packet.checklist !== null" [ngModel]="(packet.checklist !== null)" (onChange)="packetChecklistChecked($event, packet)"
                    [binary]="true"></p-checkbox>
            </td>
            <td>
                <p-checkbox [value]="packet.add !== null"  [ngModel]="(packet.add !== null)" (onChange)="packetAddChecked($event, packet)"
                    [binary]="true"></p-checkbox>
            </td>
            <td>
                <button [disabled]="!active " pButton pRipple type="button"
                    icon="pi pi-trash" (click)="deletePacketClick(packet?.id)"
                    class="p-button-rounded p-button-text p-button-success mr-2"></button>
            </td>
        </tr>
    </ng-template>

</p-table>
